import isMobile from 'ismobilejs';
import computedStyle from '../utils/computedStyle';

function checkIsMobile() {
  return isMobile(window.navigator).any && $(window).innerWidth() <= parseInt(computedStyle.get('--breakpoint-lg'));
}

export default class ClientUtils {
  init() {
    // Only on mobile - Add a spinner when clicking on the logo
    $('body').on('click', '.logo-home', function (e) {
      const isMobile = checkIsMobile();
      if (isMobile) {
        $.spinner().start();
      }
    });
  }
}
